import React from 'react';

export const AuthContext = React.createContext();
AuthContext.displayName = 'Auth context provider';

export const AuthProvider = AuthContext.Provider;
